module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nformMapping         = formMapping || {}\nconst clazz         = formMapping.class || ''\nconst tag           = formMapping.tag || 'div'\nlet message         = formMapping.message || ''\nconst messageKey    = formMapping.messageKey || ''\nif(messageKey && !message){\nmessage = storage.__(messageKey)\n}\nconst attributes = []\nlet classes = []\nif(utils.isArray(clazz)){\nclasses = classes.concat(clazz)\n} else if(typeof clazz === 'string') {\nclasses = classes.concat(clazz.trim().split(' '))\n}\nif(classes.length > 0){\nattributes.push(`class=\"${classes.join(' ')}\"`)\n}\n%><<%- tag %><%- ` ${attributes.join(' ')}` %>><%\nif(message){\n%><%- message %><%\n} else {\nutils.forEach(formMapping.content || [], function(element){\n%><%- include(element.type, { formMapping: element, model: model, config: config }); %><%\n})\n}\n%></<%- tag %>>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\accordion\\tag.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
formMapping         = formMapping || {}
const clazz         = formMapping.class || ''
const tag           = formMapping.tag || 'div'
let message         = formMapping.message || ''
const messageKey    = formMapping.messageKey || ''
if(messageKey && !message){
message = storage.__(messageKey)
}
const attributes = []
let classes = []
if(utils.isArray(clazz)){
classes = classes.concat(clazz)
} else if(typeof clazz === 'string') {
classes = classes.concat(clazz.trim().split(' '))
}
if(classes.length > 0){
attributes.push(`class="${classes.join(' ')}"`)
}

    ; __line = 20
    ; __append("<")
    ; __append( tag )
    ; __append( ` ${attributes.join(' ')}` )
    ; __append(">")
    ; 
if(message){

    ; __line = 22
    ; __append( message )
    ; 
} else {
utils.forEach(formMapping.content || [], function(element){

    ; __line = 25
    ; __append( include(element.type, { formMapping: element, model: model, config: config }) )
    ; 
})
}

    ; __line = 28
    ; __append("</")
    ; __append( tag )
    ; __append(">")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\accordion\tag.ejs

}